import { baseApi, API_TAGS, createCacheTags, createEndpointBuilder } from '@/shared/api';
import { type DangerousGoodsParams, type DangerousGoodsListResponse } from '../model/types';

const listsEndpoint = createEndpointBuilder('/api/v2/lists');

export const listsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDangerousGoods: builder.query<DangerousGoodsListResponse, DangerousGoodsParams>({
      query: ({ projectId, siteId }) => ({
        url: listsEndpoint('/dangerous-goods'),
        params: {
          projectId,
          siteId
        }
      }),
      providesTags: (_result, _error, params) =>
        createCacheTags({
          baseTag: API_TAGS.LISTS,
          params: { ...params, type: 'dangerous-goods' }
        })
    })
  })
});

export const { useGetDangerousGoodsQuery } = listsApi;
